export default (promise) =>
  promise.then((res) => res).catch((error) => error.response);
